import { Icon } from '@ets/design-system';

import { ELEMENTS } from 'Editor/services/consts';
import { DISPLAY_TYPES } from 'Editor/services/consts';
import { BaseBlockElement } from '../../BaseViewBuilder';
import styles from './RedactedElement.module.scss';
import ReactUtils from '_common/utils/ReactUtils';
import { FormattedMessage } from 'react-intl';
import { Root } from 'react-dom/client';

const RedactComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.icon}>
        <Icon disabled icon="eye-slash" size="3" testId="hide" />
      </div>
      <span className={styles.wrapper} contentEditable="true" suppressContentEditableWarning={true}>
        <span className={styles.info}>
          <FormattedMessage id="NO_PERMISSION_TO_VIEW_THIS_CONTENT" />
        </span>
      </span>
    </div>
  );
};

export class RedactedElement extends BaseBlockElement {
  private content?: HTMLElement;
  private rootReactContainer?: Root;

  static onClickListener(e: Event) {
    e.stopPropagation();
  }

  static onMouseUpListener(e: Event) {
    e.stopPropagation();
  }

  constructor() {
    super();

    this.addEventListener('click', RedactedElement.onClickListener);
    this.addEventListener('mouseup', RedactedElement.onMouseUpListener);
  }

  get displayType() {
    return DISPLAY_TYPES.BLOCK;
  }

  get isEditable() {
    return false;
  }

  get isDeletable() {
    return false;
  }

  get isSplitable() {
    return false;
  }

  get isContentWrapper() {
    return true;
  }

  get isSelectable() {
    return true;
  }

  get selectableContent() {
    return this.childNodes[0].childNodes[1] || null;
  }

  connectedCallback() {
    super.connectedCallback();

    // this.setAttribute('contentEditable', false);
    this.setAttribute('spellcheck', 'false');

    this.rootReactContainer = ReactUtils.createReactRoot(this);
    ReactUtils.renderReactComponent(<RedactComponent />, this.rootReactContainer);
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    ReactUtils.unmountReactComponent(this.rootReactContainer);

    this.removeEventListener('click', RedactedElement.onClickListener);
    this.removeEventListener('mouseup', RedactedElement.onMouseUpListener);
  }
}

if (!window.customElements.get(ELEMENTS.RedactedElement.IDENTIFIER)) {
  window.customElements.define(ELEMENTS.RedactedElement.IDENTIFIER, RedactedElement);
}
